import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  drawerIsOpen: false,
};

export const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    setDrawerIsOpen: (state, action) => {
      state.drawerIsOpen = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setDrawerIsOpen } = drawerSlice.actions;

export default drawerSlice.reducer;
